var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ki",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M161.78 5.753h491.68v491.68H161.78z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-168.47 -5.991) scale(1.0413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e73e2d",
    d: "M4.023 5.753h802.62v294.33H4.023z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.969 276.643c-18.664-14.57-53.425-9.642-59.15-49.249 26.616 20.617 21.784-1.178 61.537 18.466l-2.387 30.783z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.933 258.643c-13.302-19.589-47.902-25.547-41.218-65.003 19.02 27.78 21.098 5.552 52.921 36.43l-11.703 28.573z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.987 245.845c-4.802-23.186-34.496-41.92-13.234-75.824 6.954 32.941 17.373 13.197 34.973 53.896l-21.739 21.928z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.935 233.945c2.548-23.542-19.96-50.488 10.684-76.228-3.495 33.487 12.482 17.894 16.738 62.032l-27.422 14.196z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.348 224.39c11.963-20.434 2.458-54.233 40.954-65.171-16.898 29.12 4.063 21.435-10.125 63.447l-30.83 1.725z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.472 226.904c17.822-15.59 19.52-50.658 59.498-48.832-25.256 22.264-2.94 21.618-29.712 56.967l-29.786-8.135z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.357 236.085c21.613-9.672 33.529-42.697 71.208-29.217-30.677 13.87-9.156 19.802-45.122 45.736l-26.086-16.52z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.632 250.571c23.461-3.198 44.191-31.534 76.555-7.993-33.343 4.675-14.36 16.425-56.173 31.187l-20.382-23.194z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.207 255.065l-107.62 2.362 4.519 28.996 103.1-31.358z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.382 215.489l-99.722 38.278 16.696 32.048 83.026-70.326z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.215 275.257l51.591-93.666-79.136 73.658 27.545 20.008z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86 573.24l-13.513-82.602-15.405 82.535 28.918.067z",
    fillRule: "evenodd",
    transform: "matrix(1.2145 .40191 -.39943 1.207 195.37 -577.79)",
    stroke: "#d8aa3f",
    strokeWidth: 1.254,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.95 259.003l-17.32-105.871-19.195 106.334 36.515-.463z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51 569.67l-10.159-79.033-17.918 83.552 28.077-4.519z",
    fillRule: "evenodd",
    transform: "matrix(1.1791 -.4886 .48383 1.1816 -306.93 -238.21)",
    stroke: "#d8aa3f",
    strokeWidth: 1.253,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.21 249.288l-77.884-65.762 55.379 94.114 22.504-28.352z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.936 215.962L385.549 285l12.856-36.114-96.47-32.924z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.658 256.275l-98.247-1.38 97.835 32.66.412-31.28z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.426 273.939c0 32.552-26.389 58.941-58.941 58.941s-58.942-26.389-58.942-58.941 26.39-58.942 58.942-58.942 58.941 26.39 58.941 58.942z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#fec74a"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#005989",
    d: "M3.215 297.11h806.58v200.33H3.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.755 441.711c14.997 6.941 36.483 24.314 59.464 24.299 38.453-.25 39.477-26.336 78.428-25.096 39.053.994 31.989 28.458 84.722 28.32 43.57-.113 57.644-33.288 95.2-29.313 27.813-1.432 39.197 31.414 81.947 31.831 44.34.948 60.62-35.8 88.436-32.758 29.63 0 39.338 29.597 80.909 29.81 52.947.268 62.256-30.804 95.38-28.816 23.577-.497 42.168 22.773 76.717 23.352 27.568.47 50.647-20.371 66.238-27.824l.771-35.365c-16.34 6.077-40.704 25.999-65.067 26.218-35.06 1.283-56.749-22.995-81.112-22.776-29.191.262-40.824 30.042-90.342 30.042-45.24 0-55.62-30.042-84.811-30.042-28.533.218-37.275 32.674-86.672 32.073-40.295-.485-55.995-30.981-84.53-30.762-30.249 0-61.528 29.654-95.023 28.223-46.23-1.954-56.218-28.223-86.467-28.223-22.607 0-47.006 24.617-74.241 25.027-27.086.417-57.515-24.495-60.333-25.027l.386 36.807zm0-70.04c14.997 6.941 36.483 24.314 59.464 24.299 38.453-.25 39.477-26.336 78.428-25.096 39.053.994 31.989 28.458 84.722 28.32 43.57-.113 57.644-33.288 95.2-29.313 27.813-1.432 39.197 31.414 81.947 31.831 44.34.948 60.62-35.8 88.436-32.758 29.63 0 39.338 29.597 80.909 29.81 52.947.268 62.256-30.804 95.38-28.816 23.577-.497 42.168 22.773 76.717 23.352 27.568.47 50.647-20.371 66.238-27.824l.771-35.365c-16.34 6.077-40.704 25.999-65.067 26.218-35.06 1.283-56.749-22.995-81.112-22.776-29.191.262-40.824 30.042-90.342 30.042-45.24 0-55.62-30.042-84.811-30.042-28.533.218-37.275 32.674-86.672 32.073-40.295-.485-55.995-30.981-84.53-30.762-30.249 0-61.528 29.654-95.023 28.223-46.23-1.954-56.218-28.223-86.467-28.223-22.607 0-47.006 24.617-74.241 25.027-27.086.417-57.515-24.495-60.333-25.027l.386 36.807z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.754 302.391c14.984 6.941 36.45 24.314 59.41 24.299 38.416-.25 39.439-26.336 78.354-25.096 39.016.994 31.959 28.458 84.643 28.32 43.528-.113 57.59-33.288 95.111-29.313 27.787-1.432 39.16 31.414 81.87 31.831 44.299.948 60.565-35.8 88.353-32.758 29.604 0 39.302 29.597 80.834 29.81 52.898.268 62.198-30.804 95.292-28.816 23.554-.497 42.127 22.773 76.645 23.352 27.542.47 50.6-20.371 66.176-27.824l.77-35.365c-16.325 6.077-40.666 25.999-65.007 26.218-35.027 1.283-56.695-22.995-81.036-22.776-29.163.262-40.785 30.042-90.258 30.042-45.197 0-55.567-30.042-84.731-30.042-28.507.218-37.24 32.674-86.59 32.073-40.258-.485-55.944-30.981-84.451-30.762-30.221 0-61.472 29.654-94.935 28.223-46.187-1.954-56.166-28.223-86.387-28.223-22.586 0-46.962 24.617-74.171 25.027-27.061.417-57.462-24.495-60.277-25.027l.386 36.807z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.164 78.674c58.625-4.014 47.94-9.02 71.536-12.786 29.735 4.088 33.135 22.09 49.703 33.135 0 0-6.227 21.055-26.606 18.075-2.74-8.447 9.865-11.058-26.405-33.169-21.087-1.254-58.818 3.701-68.228-5.255zm181.761 32.62l-42.232 1.739v10.434c28.486.911 33.62-2.898 42.232-12.173z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.706,
    fill: "#ffc84b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M329.685 109.516c7.361-3.765 11.022-2.228 17.399-2.477 4.389 7.95 8.53 8.695 18.135 9.69 14.657 20.619 35.277 20.867 38.257 20.867 28.735-.746 37.844-20.868 57.138-23.104h20.371c-3.395-5.796-6.045-9.11-13.415-9.44-15.154-.828-34.778-.414-51.92 3.478l-24.097 5.962c-7.04-3.395-24.263-21.447-35.277-21.116-6.459 1.739-6.459 3.975-9.688 6.459-6.211 2.65-12.423 1.38-16.903 9.681z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#ffc84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.735 100.737a3.048 3.048 0 1 1-6.096 0 3.048 3.048 0 0 1 6.096 0z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.599,
    fill: "#ffc84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.385 109.273c43.143-52.003 80.82-45.628 129.928-49.188 1.656 6.046 1.077 15.072-22.358 23.104-32.046 4.72-89.434 38.505-89.682 38.505-10.684-.496-18.137-11.675-17.887-12.421z",
    fillRule: "evenodd",
    stroke: "#d8aa3f",
    strokeWidth: 1.706,
    fill: "#ffc84b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.02 75.387l31.82 1.379m-35.273 3.814l23.193 1.892",
    stroke: "#d9a43e",
    strokeLinecap: "round",
    strokeWidth: 1.706,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKi);
export default __webpack_public_path__ + "static/media/ki.b5d51cf39df016cfca98b3840713bdf9.svg";
export { ForwardRef as ReactComponent };